import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebUserRoutingModule } from './web-user-routing.module';
import { WebUserComponent } from './web-user.component';
import { WebUserFormComponent } from './web-user-form/web-user-form.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { MaintenanceListModule } from 'src/app/core/custom-modules/maintenance-list/maintenance-list.module';
import { MaintenanceDetailModule } from 'src/app/core/custom-modules/maintenance-detail/maintenance-detail.module';
import { WebUserFilterComponent } from './web-user-filter/web-user-filter.component';
import { RoleDropdownModule } from 'src/app/core/custom-modules/dropdowns/role-dropdown/role-dropdown.module';
import { CompanyDropdownModule } from 'src/app/core/custom-modules/dropdowns/company-dropdown/company-dropdown.module';

@NgModule({
  imports: [
    CommonModule,
    WebUserRoutingModule,
    MaintenanceListModule,
    GlobalModulesModule,
    MaintenanceDetailModule,
    RoleDropdownModule,
    CompanyDropdownModule
  ],
  declarations: [WebUserComponent, WebUserFormComponent, WebUserFilterComponent],
  entryComponents: [WebUserFilterComponent]
})
export class WebUserModule { }
